import type { BridgeData } from "../types";
import { clip } from "./math";

export function bridgeHeightAt(bridge: BridgeData, progress: number): number {
  const fraction = clip(
    (progress - bridge.start_progress) / Math.max(1e-9, bridge.end_progress - bridge.start_progress),
    0,
    1,
  );
  const ramp = clip(bridge.ramp_fraction, 0.05, 0.45);
  if (fraction < ramp) return bridge.height * fraction / ramp;
  if (fraction > 1 - ramp) return bridge.height * (1 - fraction) / ramp;
  return bridge.height;
}

export function bridgeRailHalfWidthAt(bridge: BridgeData, progress: number): number {
  const fraction = clip(
    (progress - bridge.start_progress) / Math.max(1e-9, bridge.end_progress - bridge.start_progress),
    0,
    1,
  );
  const ramp = clip(bridge.ramp_fraction, 0.05, 0.45);
  const blend = fraction < ramp
    ? fraction / ramp
    : fraction > 1 - ramp
      ? (1 - fraction) / ramp
      : 1;
  return bridge.approach_half_width
    + (bridge.deck_half_width - bridge.approach_half_width) * blend;
}
